module.exports = __webpack_public_path__ + "static/img/s34.2282cdf8.png";